export interface LocalizeString {
  en: string;
  vi: string;
}

export type SubscriptionResponse = {
  data: Subscription[];
};

export interface Subscription {
  _id: string;
  start_time: number;
  end_time: number;
  enable: boolean;
  title: LocalizeString;
  description: LocalizeString;
  plans: SubscriptionPlan[];
  promo_code_start_time: number;
  instruction: LocalizeString;
  city_ids: string[];
  is_auto_renew: boolean;
  changelogs: Changelog[];
  excluded_tags?: string[];
  icon_url: string;
  display_tag_url: string;
}

export interface SubscriptionPlan {
  id: string;
  price: number;
  promo_code_samples: PromoCodeSample[];
  title: LocalizeString;
  life_time_in_days: number;
  max_use_per_user: number;
  max_use: number;
  discount_value: number;
  original_price?: number;
  saving: number;
}

export interface ProgressesSubscriptionDetailList {
  data: ProgressesSubscriptionDetail[];
}

export interface ProgressesSubscriptionDetail {
  _id: string;
  user_id: string;
  subscription_id: string;
  plan_id: string;
  create_time: number;
  end_time: number;
  is_auto_renew: boolean;
  created_by: string;
  promo_codes_detail: PromoCodesDetail[];
  title: LocalizeString;
  price: number;
  life_time_in_days: number;
  image_url: string;
  term_and_condition: LocalizeString;
  term_and_condition_title: LocalizeString;
  term_and_condition_url: string;
  label: LocalizeString & {
    type: LabelType;
  };
  total_discount: number;
}

export interface PromoCodesDetail {
  id: string;
  call_to_action_text: LocalizeString;
  call_to_action_url: string;
  call_to_action_web_url: string;
  max_use: number;
  use_left: number;
  title: LocalizeString;
  icon_url: string;
}

export type ProgressesSubscriptionResponse = {
  data: ProgressesSubscriptionData[];
};

export type ProgressesSubDetailResponse = {
  data: ProgressesSubscriptionDetail;
};

export type ProgressesSubscriptionData = {
  _id: string;
  user_id: string;
  subscription_id: string;
  plan_id: string;
  create_time: number;
  end_time: number;
  is_auto_renew: boolean;
  created_by: string;
  title: ProgressesSubscriptionDetail;
  description: ProgressesSubscriptionDetail;
  price: number;
  life_time_in_days: number;
  icon_url: string;
  use_left: number;
  max_use: number;
  label: LocalizeString & {
    type: LabelType;
  };
};

export interface SubscriptionDetailResponse {
  data: SubscriptionDetail;
}

export interface SubscriptionDetail {
  _id: string;
  start_time: number;
  end_time: number;
  enable: boolean;
  title: LocalizeString;
  description: LocalizeString;
  plans: SubscriptionPlan[];
  promo_code_start_time: number;
  instruction: LocalizeString;
  city_ids: string[];
  is_auto_renew: boolean;
  changelogs: Changelog[];
  excluded_tags: string[];
  icon_url: string;
  image_url: string;
  display_tag_url: string;
  term_and_condition_url: string;
  term_and_condition: LocalizeString;
  term_and_condition_title: LocalizeString;
}

interface PromoCodeSample {
  id: string;
  icon_url: string;
  title: LocalizeString;
  max_use: number;
}

interface Changelog {
  actor: string;
  time: number;
  type: string;
}

export enum LabelType {
  ACTIVE = 'ACTIVE',
  EXPIRES_SOON = 'EXPIRES_SOON',
  USED = 'USED',
}
